import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
  PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';

import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

export class MenuCteos extends Component {
  render() {
    return (
      <>
        <div className="area-home">
          <Titulo texto="CT-e OS" urlRetorno="/gestao-empresa" />
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
              getGestorEmpresa(this.props.empresaSelecionada.id)]}>
            <div className="vx-quick-actions mt-3">
              <Link to="/painel-tomadores" className="vx-action-card">
                <div className="vx-action-icon-wrap c-orange">
                  <PeopleAltOutlinedIcon />
                </div>
                <div>
                  <p className="vx-action-title">Gerenciar Tomadores</p>
                  <p className="vx-action-desc">
                    <span className="material-icons">people_alt</span>
                    Cadastro e gestão de tomadores
                  </p>
                </div>
              </Link>
              <Link to="/painel-cte-os" className="vx-action-card">
                <div className="vx-action-icon-wrap c-orange">
                  <span className="material-icons">receipt_long</span>
                </div>
                <div>
                  <p className="vx-action-title">Gerenciar CT-e OS</p>
                  <p className="vx-action-desc">
                    <span className="material-icons">receipt_long</span>
                    Emissão e controle de CT-e OS
                  </p>
                </div>
              </Link>
            </div>
          </Autorizacao>
        </div>
      </>
    );
  }
}
export function mapStateToProps(state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    authentication: state.authentication
  }
}



export default withRouter(connect(mapStateToProps, {})(MenuCteos));
